import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static targets = [
    "form",
    "input",
    "progressContainer",
    "progressBar",
    "progressText",
    "fileName",
    "submitButton",
    "buttonText",
    "spinner",
    "buttons",
  ];

  connect() {
    this.uploading = false;
    
    // Prevent the default direct upload UI from showing
    this.boundPreventDefaultUI = this.preventDefaultUI.bind(this);
    this.element.addEventListener("direct-upload:initialize", this.boundPreventDefaultUI);
  }

  disconnect() {
    this.element.removeEventListener("direct-upload:initialize", this.boundPreventDefaultUI);
  }

  preventDefaultUI(event) {
    // Stop the default direct upload progress UI from being added
    event.stopPropagation();
  }

  submit(event) {
    const file = this.inputTarget.files[0];

    if (!file) {
      return; // Let the form validation handle this
    }

    // Prevent the default form submission
    event.preventDefault();

    if (this.uploading) {
      return;
    }

    this.uploading = true;
    this.showProgress(file);

    const url = this.inputTarget.dataset.directUploadUrl;
    const upload = new DirectUpload(file, url, this);

    upload.create((error, blob) => {
      if (error) {
        this.handleError(error);
      } else {
        this.handleSuccess(blob);
      }
    });
  }

  showProgress(file) {
    // Show progress container
    this.progressContainerTarget.classList.remove("hidden");

    // Update file name
    this.fileNameTarget.textContent = file.name;

    // Disable submit button and show spinner
    this.submitButtonTarget.disabled = true;
    this.spinnerTarget.classList.remove("hidden");
    this.buttonTextTarget.textContent = "Uploading...";

    // Hide the file input
    this.inputTarget.disabled = true;
  }

  // DirectUpload delegate methods
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) => {
      this.updateProgress(event);
    });
  }

  updateProgress(event) {
    const progress = Math.round((event.loaded / event.total) * 100);
    this.progressBarTarget.style.width = `${progress}%`;
    this.progressTextTarget.textContent = `${progress}%`;
  }

  handleSuccess(blob) {
    // Update button text
    this.buttonTextTarget.textContent = "Starting import...";

    // Create a hidden input with the signed blob ID
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "signed_blob_id";
    hiddenInput.value = blob.signed_id;
    this.formTarget.appendChild(hiddenInput);

    // Remove the file input name so it doesn't try to upload again
    this.inputTarget.name = "";

    // Submit the form
    this.formTarget.submit();
  }

  handleError(error) {
    console.error("Direct upload error:", error);

    // Reset state
    this.uploading = false;
    this.progressContainerTarget.classList.add("hidden");
    this.submitButtonTarget.disabled = false;
    this.spinnerTarget.classList.add("hidden");
    this.buttonTextTarget.textContent = "Start Import";
    this.inputTarget.disabled = false;

    // Show error
    alert(`Upload failed: ${error}`);
  }
}
